import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class StudySelectorRadioButtons extends Component {
  constructor(props) {
    super(props);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.defaultSelectedOption !== nextProps.defaultSelectedOption) {
      if (nextProps.defaultSelectedOption === 1) {
        this.population.click();
      } else {
        this.household.click();
      }
    }
  }

  render() {
    return (
      <div className="row expanded radio-group">
        <div className="large-12 columns text-left">
          <input
            type="radio"
            name="WeightsOptions"
            id="population"
            ref={node => (this.population = node)}
            onClick={() => this.props.handleWeightTypeChange(1)}
            defaultChecked={this.props.defaultSelectedOption === 1}
          />
          <label htmlFor="population" className="margin-left-0">
            Population
          </label>
          <span>/</span>
          <input
            type="radio"
            name="WeightsOptions"
            id="household"
            ref={node => (this.household = node)}
            onClick={() => this.props.handleWeightTypeChange(2)}
            defaultChecked={this.props.defaultSelectedOption === 2}
          />
          <label htmlFor="household">Household</label>
        </div>
      </div>
    );
  }
}

StudySelectorRadioButtons.propTypes = {
  handleWeightTypeChange: PropTypes.func,
  defaultSelectedOption: PropTypes.number,
};
